<template>
  <div class="header-wrapper">
    <div class="head-cont">
      <img src="../../../assets/images/logoTN.png" alt="" />
      <div class="nav-list">
        <!-- <div @click="changeColor">微信公众号</div> -->
        <!-- <div>{{ $t("common.title") }}</div>
        <div @click="toLink(taobao)">{{ $t("common.tb") }}</div> -->
        <!-- <div v-clipboard:copy="kefu" v-clipboard:success="toCopy">
          {{ $t("common.kf") }}
          </div> -->
        <!-- <Button-b value="客服聯係方式" @click.native="toCopy" v-clipboard="kefu" style="background-color: transparent;"></Button-b> -->
        <div @click="toLink()">{{ $t("common.jx") }}</div>
        <div @click="qiehuan">{{ $t("common.yy") }}</div>
        <!-- 登录  -->
        <div @click="loginone" v-if="!login">{{ $t("login.three") }}</div>
        <!-- 退出 -->
        <div @click="tz()" v-if="login">{{ $t("common.tc") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gameUserInfo: null,
      gw: "http://www.hkexpressworld.com/",
      login: false,
      showBtn: false,
      // kefu: '17328359508'
    };
  },
  created() {
    if (localStorage.getItem("userID")) {
      this.login = true;
    } else {
      this.login = false;
    }
  },
  methods: {
    // toCopy() {
    //   this.$Message.success("成功複製");
    // },
    // 这个方法
    loginone(route) {
      this.showBtn = !this.showBtn;
      this.$emit("getIsshow", this.showBtn);
    },
    qiehuan() {
      if (!localStorage.getItem("locale") || localStorage.getItem("locale") == "zh") {
        this.$i18n.locale = "en";
        localStorage.setItem("locale", "en");
      } else {
        this.$i18n.locale = "zh";
        localStorage.setItem("locale", "zh");
      }
    },
    changeColor() {
      window.document.documentElement.setAttribute("data-theme", "primary2");
    },
    toLink() {
      this.$router.push("./noviceguidance")
    },
    toLinkgw() {},
    tz() {
      localStorage.removeItem("CusID");
      localStorage.removeItem("userID");
      localStorage.removeItem("KeyText");
      localStorage.removeItem("token");
      this.$router.push("./login");
    },
  },
};
</script>
<style lang="scss" scoped>
.header-wrapper {
  width: 100%;
  height: 80px;
  line-height: 80px;
  font-size: 16px;
  color: #000;
  background: #fff;
  // @include backgroundColor($_color);
  .head-cont {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    img {
      width: 190px;
      position: relative;
      left: -650px;
      height: 78px;
      cursor: pointer;
    }
    .nav-list {
      display: flex;
      flex-direction: row;
      > div {
        // color:#fff;
        margin-left: 56px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/layout/header/index.vue